import React, { Fragment, useEffect } from "react";
import { Form, Input, Button, DatePicker, message } from "antd";
import {
  createRevokedLicense,
  updateRevokedLicense,
} from "../../../../../services/vendorProfile.services";
import moment from "moment";
import { numberValidation } from "../../../../../config/validation.config";
import DrawerWizz from "../../../../../reusable/DrawerWizz";

const RevokedLicenseModal = ({
  title,
  setVisible,
  vendorId,
  editTable,
  refresh,
}) => {
  const [form] = Form.useForm();

  //Disable Date greater than today
  function disabledDate(current) {
    return current && current > moment().endOf("day");
  }

  useEffect(() => {
    if (editTable.status === "update") {
      setFormFieldValues(editTable);
    }
  }, []);

  function setFormFieldValues(data) {
    form.setFieldsValue({
      ...data,
      exp_date: moment(data.exp_date),
    });
  }

  const handleCancel = () => {
    setVisible(false);
    refresh();
  };

  const onFinish = (values) => {
    if (editTable.status === "update") {
      const formData = {
        ...values,
        vendor_id: vendorId,
        id: editTable.id,
        exp_date: moment(values.exp_date).format("YYYY-MM-DD"),
      };

      updateRevokedLicense(formData)
        .then((response) => {
          message.success(response.data.message);
          handleCancel();
        })
        .catch((error) => console.error(error));
    } else {
      const formData = {
        ...values,
        vendor_id: vendorId,
        exp_date: moment(values.exp_date).format("YYYY-MM-DD"),
      };

      createRevokedLicense(formData)
        .then((response) => {
          message.success(response.data.message);
          handleCancel();
        })
        .catch((error) => console.error(error));
    }
  };

  return (
    <Fragment>
      <DrawerWizz
        title={title}
        handleCancel={handleCancel}
        content={
          <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
            scrollToFirstError
          >
            <Form.Item
              name="revoked_license_type"
              label="Revoked License Type"
              rules={[
                {
                  required: true,
                  message: "Please input your revoked license type!",
                },
              ]}
            >
              <Input placeholder="Revoked License Type" />
            </Form.Item>
            <Form.Item
              name="revoked_application"
              label="Name on License or Application"
              rules={[
                {
                  required: true,
                  message: "Please input your  revoked application!",
                },
              ]}
            >
              <Input placeholder="Name on License or Application" />
            </Form.Item>
            <Form.Item
              name="revoked_license_number"
              label="Revoked License Number"
              rules={numberValidation}
            >
              <Input placeholder="Revoked License Number" />
            </Form.Item>
            <Form.Item
              name="exp_date"
              label="Revoked Date"
              rules={[
                {
                  required: true,
                  message: "Please input date!",
                },
              ]}
            >
              <DatePicker
                allowClear={false}
                disabledDate={disabledDate}
                placeholder="Revoked Date"
                size="large"
                style={{ minWidth: "280px" }}
              />
            </Form.Item>
            <Form.Item
              name="reason_for_revocation"
              label="Reason for Revocation"
              rules={[
                {
                  required: true,
                  message: "Please input reason for revocation!",
                },
              ]}
            >
              <Input placeholder="Reason For Revocation" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        }
      />
    </Fragment>
  );
};

export default RevokedLicenseModal;
